import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventStockQueryVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
  start_date?: Types.InputMaybe<Types.Scalars['String']>;
  end_date?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetEventStockQuery = { __typename?: 'Query', getEventStock: { __typename?: 'EventStock', prices: Array<{ __typename?: 'EventAccountStockPrice', type: Types.EventAccountStockPriceType, id_number?: number | null, id_text?: string | null, price_in_cents: number, currency: string }>, container_types: Array<{ __typename?: 'ContainerType', id: number, name: string, image?: string | null }>, item_location_stock: Array<{ __typename?: 'ItemLocationStockEntry', id: string, name: string, container_deliveries: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, amount: number }>, containers_used: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, amount: number }>, container_returns: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, amount: number, amount_sealed: number }>, goodwill: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, amount: number, amount_sealed: number }>, container_station_deliveries: Array<{ __typename?: 'ContainerStationStockEntry', id: string, name: string, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null } }>, container_station_returns: Array<{ __typename?: 'ContainerStationStockEntry', id: string, name: string, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null } }>, container_totals: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, amount: number }> }> } };


export const GetEventStockDocument = gql`
    query GetEventStock($event_id: ID!, $start_date: String, $end_date: String) {
  getEventStock(event_id: $event_id, start_date: $start_date, end_date: $end_date) {
    prices {
      type
      id_number
      id_text
      price_in_cents
      currency
    }
    container_types {
      id
      name
      image
    }
    item_location_stock {
      id
      name
      container_deliveries {
        container_type_id
        amount
      }
      containers_used {
        container_type_id
        amount
      }
      container_returns {
        container_type_id
        amount
        amount_sealed
      }
      goodwill {
        container_type_id
        amount
        amount_sealed
      }
      container_station_deliveries {
        id
        name
        item_type {
          id
          name
          color_hex_code
          category
          epc_asset_id
          image_url
        }
      }
      container_station_returns {
        id
        name
        item_type {
          id
          name
          color_hex_code
          category
          epc_asset_id
          image_url
        }
      }
      container_totals {
        container_type_id
        amount
      }
    }
  }
}
    `;

/**
 * __useGetEventStockQuery__
 *
 * To run a query within a React component, call `useGetEventStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventStockQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *   },
 * });
 */
export function useGetEventStockQuery(baseOptions: Apollo.QueryHookOptions<GetEventStockQuery, GetEventStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventStockQuery, GetEventStockQueryVariables>(GetEventStockDocument, options);
      }
export function useGetEventStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventStockQuery, GetEventStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventStockQuery, GetEventStockQueryVariables>(GetEventStockDocument, options);
        }
export type GetEventStockQueryHookResult = ReturnType<typeof useGetEventStockQuery>;
export type GetEventStockLazyQueryHookResult = ReturnType<typeof useGetEventStockLazyQuery>;
export type GetEventStockQueryResult = Apollo.QueryResult<GetEventStockQuery, GetEventStockQueryVariables>;